export const DRAWER_COLLAPSED_WIDTH = 56;
export const DRAWER_EXPANDED_WIDTH_DEFAULT = 280;
export const DRAWER_EXPANDED_WIDTH_MIN = DRAWER_EXPANDED_WIDTH_DEFAULT / 2;
export const DRAWER_EXPANDED_WIDTH_MAX = window.innerWidth * 0.4;
export const DRAWER_RESIZE_BAR_WIDTH = 8;

/** Profile setting keys are `{settingsKey}` + suffix (LB-4992). */
export const SIDEBAR_COLLAPSED_SETTING_SUFFIX = '.sidebar.collapsed';
export const SIDEBAR_WIDTH_SETTING_SUFFIX = '.sidebar.width';
